import type { RefObject } from "react";
import { useEffect, useState } from "react";
import type { TamaguiElement } from "tamagui";

/** focus target element when trigger element is focused */
export const useForwardFocus = (target: RefObject<TamaguiElement | null>) => {
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (focused && target.current) {
      target.current.focus();
    }
  }, [focused, target]);
  /** apply this object on focus trigger element */
  return {
    onPress: () => {
      setFocused(true);
    },
    onBlur: () => {
      setFocused(false);
    },
    focusable: true
  };
};